export default __webpack_public_path__ + "static/media/bookBlue.aae9146c.svg";